export default ['heart-on',
  'star-on',
  'sliders',
  'gitlab',
  'maximize',
  'minimize',
  'wifi-off',
  'tv',
  'shopping-cart',
  'paperclip',
  'help-circle',
  'crop',
  'bold',
  'italic',
  'underline',
  'headphones',
  'hash',
  'cloud',
  'command',
  'zoom-out',
  'zoom-in',
  'zap',
  'x-circle',
  'x',
  'wind',
  'x-square',
  'wifi',
  'watch',
  'volume',
  'volume-1',
  'volume-2',
  'volume-x',
  'voicemail',
  'video',
  'video-off',
  'users',
  'user',
  'user-x',
  'user-plus',
  'user-minus',
  'user-check',
  'unlock',
  'upload-cloud',
  'umbrella',
  'upload',
  'twitter',
  'type',
  'triangle',
  // 'triangle-down',
  // 'triangle-up',
  'trash',
  'trash-2',
  'toggle-right',
  'toggle-left',
  'thumbs-down',
  'thumbs-up',
  'thermometer',
  'target',
  'sunset',
  'tag',
  'tablet',
  'sunrise',
  'sun',
  'stop-circle',
  'star',
  'speaker',
  'square',
  'smartphone',
  'slash',
  'slack',
  'skip-forward',
  'sidebar',
  'shuffle',
  'skip-back',
  'settings',
  'shield',
  'share',
  'share-2',
  'scissors',
  'server',
  'search',
  'save',
  'rotate-cw',
  'refresh-cw',
  'rotate-ccw',
  'rewind',
  'refresh-ccw',
  'repeat',
  'radio',
  'power',
  'printer',
  'pocket',
  'plus',
  'plus-circle',
  'plus-square',
  'play',
  'play-circle',
  'pie-chart',
  'phone-outgoing',
  'phone',
  'phone-incoming',
  'phone-off',
  'phone-missed',
  'phone-forwarded',
  'phone-call',
  'percent',
  'pause',
  'pause-circle',
  'package',
  'octagon',
  'navigation',
  'navigation-2',
  'music',
  'move',
  'more-horizontal',
  'more-vertical',
  'monitor',
  'moon',
  'minus',
  'minus-square',
  'mic',
  'minus-circle',
  'mic-off',
  'minimize-2',
  'message-square',
  'message-circle',
  'menu',
  'map-pin',
  'map',
  'maximize-2',
  'mail',
  'loader',
  'log-out',
  'lock',
  'list',
  'log-in',
  'link',
  'life-buoy',
  'link-2',
  'layout',
  'instagram',
  'info',
  'layers',
  'inbox',
  'image',
  'github',
  'home',
  'heart',
  'grid',
  'globe',
  'flag',
  'filter',
  'folder',
  'file-plus',
  'file',
  'film',
  'file-text',
  'fast-forward',
  'eye-off',
  'file-minus',
  'facebook',
  'feather',
  'eye',
  'external-link',
  'edit-1',
  'edit',
  'edit-2',
  'droplet',
  'download',
  'download-cloud',
  'delete',
  'disc',
  'crosshair',
  'credit-card',
  'cpu',
  'corner-right-up',
  'corner-right-down',
  'corner-up-right',
  'corner-up-left',
  'corner-left-up',
  'corner-left-down',
  'corner-down-left',
  'corner-down-right',
  'copy',
  'compass',
  'cloud-snow',
  'codepen',
  'cloud-off',
  'cloud-rain',
  'cloud-drizzle',
  'cloud-lightning',
  'clock',
  'chrome',
  'clipboard',
  'circle',
  'chevrons-left',
  'chevrons-up',
  'chevrons-right',
  'chevrons-down',
  'chevron-up',
  'chevron-right',
  'chevron-left',
  'chevron-down',
  'cast',
  'check-square',
  'check',
  'check-circle',
  'camera',
  'box',
  'bookmark',
  'calendar',
  'camera-off',
  'briefcase',
  'book',
  'bell',
  'bluetooth',
  'battery',
  'bell-off',
  'battery-charging',
  'bar-chart-2',
  'bar-chart',
  'award',
  'arrow-up',
  'arrow-up-right',
  'arrow-up-left',
  'arrow-down',
  'arrow-right',
  'arrow-left',
  'aperture',
  'anchor',
  'arrow-down-right',
  'arrow-down-left',
  'align-right',
  'align-left',
  'align-justify',
  'airplay',
  'align-center',
  'alert-triangle',
  'activity',
  'alert-circle',
  'alert-octagon'
]



// WEBPACK FOOTER //
// ./src/view/icon/icon.js